import React from 'react';
import { Row, Col } from 'react-bootstrap'

class Fields extends React.Component {
    render() {
        const dictionary = Object.entries(this.props.fields);

        const fields = dictionary.map((f, i) => {
            const key = f[0];
            const value = f[1];

            return (
                <div key={i} style={{ marginLeft: '50px' }}>
                    <Row>
                        <Col md={2}>
                            <span className="log">{key}</span>
                        </Col>
                        <Col md={9}>
                            <span className="log">{value}</span>
                        </Col>
                    </Row>
                    <hr />
                </div>
            )
        });

        return (
            <div style={{ marginTop: '20px' }}>
                {fields}
            </div>)
    }
}

export default Fields;



// WEBPACK FOOTER //
// ./src/areas/admin/console/logs/Fields.js